import { DesignSystem } from '@/src/design-system'
import { Image } from 'expo-image'
import { H4, Paragraph, View, YStack } from 'tamagui'
import { ScheduleCallButton } from '../ScheduleCallButton'
import * as Mortgage from '@/src/experiences/mortgage'
import { StateCallPromoCardSkeleton } from './StateCallPromoCardSkeleton'
import { useStateCode } from '@/src/common/hooks/useMortgageModuleGeoIPBehavior'

export { StateCallPromoCardSkeleton }

export function StateCallPromoCard() {
  const stateCodeResult = useStateCode()
  const stateConfig = Mortgage.Hooks.useStateConfig(stateCodeResult)

  if (stateConfig === 'loading') {
    return <StateCallPromoCardSkeleton />
  }

  if (!stateConfig.enableScheduleACall) {
    return null
  }

  const stateCode =
    typeof stateCodeResult === 'object' && 'stateCode' in stateCodeResult
      ? stateCodeResult.stateCode
      : undefined

  return (
    <DesignSystem.SplitCard>
      <DesignSystem.SplitCard.ImageHeader containerStyle={{ height: 180 }}>
        <Image
          source={{ uri: stateConfig.image }}
          placeholder={{ thumbhash: stateConfig.thumbhash }}
          contentFit="cover"
          style={{ height: 180 }}
          transition={500}
        />
      </DesignSystem.SplitCard.ImageHeader>
      <DesignSystem.SplitCard.Content>
        <YStack gap="$2" items="stretch">
          <H4>Hello, {stateConfig.name}!</H4>
          <Paragraph size="$4">
            Mesa Mortgage is available in {stateConfig.name}. We're transforming your largest
            investment into membership rewards. Earn 1,000 Mesa Points when you chat with a Mesa
            Loan Expert to learn more.
          </Paragraph>
          <View mt="$4" mb="$2">
            <ScheduleCallButton stateCode={stateCode} />
          </View>
        </YStack>
      </DesignSystem.SplitCard.Content>
    </DesignSystem.SplitCard>
  )
}
